// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-hotel-to-booking-air{-ms-flex-preferred-size:50px;flex-basis:50px;min-width:50px;height:50px;padding-right:0;padding-left:0;margin:0}@media (min-width:768px){.h-hotel-to-booking-air{-ms-flex-preferred-size:60px;flex-basis:60px;width:60px;height:52px}}.h-hotel-to-booking-air .h-btn__stack-main{font-size:10px;line-height:1}.h-hotel-to-booking-air .h-btn__stack-sub{font-size:8px;line-height:1}", ""]);
// Exports
module.exports = exports;
